import { combineReducers } from 'redux';

import {
    REQUEST_CHECKOUT_PAY,
    SUCCESS_CHECKOUT_PAY,
    FAILURE_CHECKOUT_PAY,
    REQUEST_CHECKOUT_DETAILS,
    SUCCESS_CHECKOUT_DETAILS,
    FAILURE_CHECKOUT_DETAILS
} from './constants';

const widgetLink = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_CHECKOUT_PAY:
            return action.response.payload.widgetLink;
        case REQUEST_CHECKOUT_PAY:
        case FAILURE_CHECKOUT_PAY:
            return null;
        default:
            return state;
    }
};

const fetchingCheckoutPay = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CHECKOUT_PAY:
            return true;
        case FAILURE_CHECKOUT_PAY:
        case SUCCESS_CHECKOUT_PAY:
            return false;
        default:
            return state;
    }
};

const errorCheckoutPay = (state = '', action) => {
    switch (action.type) {
        case FAILURE_CHECKOUT_PAY:
            return action.response.message;
        case REQUEST_CHECKOUT_PAY:
        case SUCCESS_CHECKOUT_PAY:
            return '';
        default:
            return state;
    }
};

const details = (state = null, action) => {
    switch (action.type) {
        case SUCCESS_CHECKOUT_DETAILS:
            return action.response.payload;
        case REQUEST_CHECKOUT_DETAILS:
        case FAILURE_CHECKOUT_DETAILS:
            return null;
        default:
            return state;
    }
};

const fetchingDetails = (state = false, action) => {
    switch (action.type) {
        case REQUEST_CHECKOUT_DETAILS:
            return true;
        case FAILURE_CHECKOUT_DETAILS:
        case SUCCESS_CHECKOUT_DETAILS:
            return false;
        default:
            return state;
    }
};

const errorDetails = (state = '', action) => {
    switch (action.type) {
        case FAILURE_CHECKOUT_DETAILS:
            return action.response.message;
        case REQUEST_CHECKOUT_DETAILS:
        case SUCCESS_CHECKOUT_DETAILS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    widgetLink,
    fetchingCheckoutPay,
    errorCheckoutPay,
    details,
    fetchingDetails,
    errorDetails
});



// WEBPACK FOOTER //
// ./src/services/checkout/reducer.js